module.exports = __webpack_public_path__ + "static/media/3.8.cd2cd195.png";